import { Box } from '@mui/material'
import { FC, ReactNode } from 'react'

interface CenteredCardLayoutProps {
    children: ReactNode
}

/**
 * Centered card layout for authenticated pages.
 * Use this with LoginCard for approval flows and similar pages
 * that need a centered card within the normal app chrome (AppBar/Sidebar).
 *
 * Unlike LoginLayout (which provides its own header and background for
 * unauthenticated pages), this layout just centers content within
 * the existing authenticated page structure.
 */
export const CenteredCardLayout: FC<CenteredCardLayoutProps> = ({ children }) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 200px)',
            py: 4,
        }}
    >
        {children}
    </Box>
)
